// extracted by mini-css-extract-plugin
export default {"description-body":"MyToolTip_description-body__sxG2D","description-title":"MyToolTip_description-title__nkFQj"};